import { render, staticRenderFns } from "./NewDeliverableForm.vue?vue&type=template&id=55a3c76d"
import script from "./NewDeliverableForm.vue?vue&type=script&lang=js"
export * from "./NewDeliverableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports